export default __webpack_public_path__ + "assets/images/2a9fef1e3e2e082fc4a6db1474646e09.jpg";